import { DrawerComponentProps } from '@/components/drawer';
import { FC } from 'react';
import {
  OrderInboundsOrderList,
  type Props as OrderInboundsOrderListProps,
} from '@/screens/order-inbounds/order-inbounds-order-list/order-inbounds-order-list';
import { StatusBar, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTheme } from '@/contexts/theme-context';

interface OrderInboundsOrderListDrawerExtendedState {
  orderInboundsOrderListProps?: OrderInboundsOrderListProps;
}

export const OrderInboundsOrderListDrawerContent: FC<
  DrawerComponentProps<OrderInboundsOrderListDrawerExtendedState>
> = ({ extendedState }) => {
  const insets = useSafeAreaInsets();
  const theme = useTheme();

  if (!extendedState?.orderInboundsOrderListProps) {
    return null;
  }

  return (
    <View style={[styles.container, { paddingTop: insets.top }]}>
      <StatusBar backgroundColor={theme.colors.white} barStyle="dark-content" />

      <OrderInboundsOrderList {...extendedState.orderInboundsOrderListProps} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
